<template>
  <div class="warranty-request pad">
    <div class="pad">

      <h5 class="title is-6 no-margin no-padding">Before filling in this form, Please ensure you have the following infomation handy:</h5>
      <ul>
        <li>Proof of purchase (Tax Invoice)</li>
        <li>The correct model number of the product</li>
      </ul>

      <h5 class="title is-6 no-margin no-padding">What happens after you submit this form:</h5>
      <ul>
        <li>A VMS technician will evaluate whether the product need to be returned for assessment.</li>
        <li>If the fault described is a valid for warranty, we’ll contact you via email along with instructions on how the product should be returned. Please also include a copy of your proof of purchase for warranty claim purposes.</li>
        <li>If the faults are not warrantable, we’ll contact you via email along with an explanation.</li>
      </ul>

      <return-authorisation-form @submitted="submitted" :editable="editable" />

      <div class="columns" v-if="showSubmitted">
        <div class="column pad-top pad-bottom">
          <b-message title="Service Request Submitted" size="is-medium" :closable="false">
            <p>An automated response will be sent to the provided email address shortly.</p>
            <p>If you do not recieve an email within 1 hour, please check your your Junk/Spam box.</p>
          </b-message>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import ReturnAuthorisationForm from '@/components/ReturnAuthorisationForm'
export default {
  name: 'WarrantyRequest',
  components: {
    ReturnAuthorisationForm
  },
  data () {
    return {
      showSubmitted: false,
      editable: true
    }
  },
  methods: {
    submitted () {
      this.showSubmitted = true
      this.editable = false
    }
  }
}
</script>

<style>
 .warranty-request {
   max-width: 1024px;
   margin: 0 auto;
 }

 .warranty-request ul {
   list-style: disc;
   font-size: 0.85em;
   padding: 10px 0 20px 20px;
 }
</style>
